// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"4bd4159f","544":"ce50e294","701":"c4c905b7","805":"8f687773","867":"a762ddfa","969":"56853ba1","996":"82ec0af4"}[chunkId] + ".chunk.js";
};